module.exports = __webpack_public_path__ + "img/tp1.a856a21f.jpg";